import React from "react";
import { Divider } from "antd";

/**
 * AllQuestionsView
 * Renders each question's "componentForAllQuestions"
 * so the user can see & edit all answers in one place.
 *
 * PROPS:
 * - pathQuestions: An object containing question configs
 * - state: The local (temporary) answers object
 * - handleQuestionChange(questionId, newVal): Called whenever a question's answer changes
 * - onSaveAll(): Called when the user clicks "Save and Continue" to commit all changes
 */
const AllQuestionsView = ({
  pathQuestions,
  state,
  handleQuestionChange,
  onSaveAll,
}) => {
  return (
    // The parent container for scrolling
    <div className="max-h-[70vh] overflow-y-auto relative">
      {/* Sticky toolbar at the top */}
      <div className="sticky top-0 z-50 bg-white p-4 flex justify-center">
        <button
          onClick={onSaveAll}
          className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-full shadow-lg"
        >
          Save and Continue
        </button>
      </div>


      {Object.keys(pathQuestions).map((questionId) => {
        const questionConfig = pathQuestions[questionId];
        if (!questionConfig?.title) return null;
        if (!questionConfig?.componentForAllQuestions) return null;

        const InlineQuestion = questionConfig.componentForAllQuestions;
        const value = state[questionId];

        return (
          <div key={questionId} className="my-6 p-6 max-w-[700px] !mx-auto">
            <h4 className="text-base font-medium mb-2">
              {questionConfig.title}
            </h4>
            <InlineQuestion
              value={value}
              onChange={(newVal) => handleQuestionChange(questionId, newVal)}
            />
            <Divider className="my-1" />
          </div>
        );
      })}
    </div>
  );
};

export default AllQuestionsView;
